@mixin pgm-label-large-typography {
  font-family: var(--pgm-sys-typescale-label-large-font);
  font-size: var(--pgm-sys-typescale-label-large-size);
  font-style: normal;
  font-weight: var(--pgm-sys-typescale-label-large-weight);
  line-height: var(--pgm-sys-typescale-label-large-line-height);
  letter-spacing: var(--pgm-sys-typescale-label-large-tracking);
}

@mixin pgm-body-medium-typography {
  font-family: var(--pgm-sys-typescale-body-medium-font);
  font-size: var(--pgm-sys-typescale-body-medium-size);
  font-style: normal;
  font-weight: var(--pgm-sys-typescale-body-medium-weight);
  line-height: var(--pgm-sys-typescale-body-medium-line-height);
  letter-spacing: var(--pgm-sys-typescale-body-medium-tracking);
}

@mixin pgm-body-small-typography {
  font-family: var(--pgm-sys-typescale-body-small-font);
  font-size: var(--pgm-sys-typescale-body-small-size);
  font-style: normal;
  font-weight: var(--pgm-sys-typescale-body-small-weight);
  line-height: var(--pgm-sys-typescale-body-small-line-height);
  letter-spacing: var(--pgm-sys-typescale-body-small-tracking);
}

.item-inscricao,
.item-inscricao-v2 {
  width: 100%;
  border: 0;
  outline: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.item-inscricao-actions {
  position: relative;
  display: flex;
  width: 100%;
}

.item-inscricao-v2 > .item-inscricao-actions > .option {
  flex: 1 1 100%;
  width: 100%;
  min-width: 0;
  padding: var(--pgm-sys-spacing-0);
  background: transparent;
}

.inscriptionInformation {
  --row-indent: var(--pgm-sys-spacing-10);

  position: relative;
  display: grid;
  grid-template-columns: var(--pgm-sys-spacing-12) minmax(0, 1fr) auto;
  align-items: center;
  width: calc(100% - var(--row-indent));
  height: var(--pgm-sys-spacing-12);
  min-height: var(--pgm-sys-spacing-12);
  box-sizing: border-box;
  margin-left: var(--row-indent);
  padding: var(--pgm-sys-spacing-0);
  border: 0;
  background: transparent;
}

.inscriptionInformation::after,
.inscriptionContent::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 1px;
  background: var(--pgm-sys-color-outline-variant);
  content: "";
}

.lastCda::after {
  content: none;
}

.administrativeToggleButton {
  --md-icon-button-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-icon-button-focus-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-icon-button-hover-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-icon-button-pressed-icon-color: var(--pgm-sys-color-on-surface-variant);

  justify-self: center;
}

.administrativeToggleButton :global(.material-symbols-sharp) {
  width: var(--pgm-sys-spacing-5);
  height: var(--pgm-sys-spacing-5);
  font-size: var(--pgm-sys-spacing-5);
  line-height: var(--pgm-sys-spacing-5);
}

.administrativeTitle {
  display: flex;
  align-items: center;
  min-width: 0;
  box-sizing: border-box;
}

.administrativeInscription {
  margin-right: var(--pgm-sys-spacing-1);
}

.administrativeTotal {
  display: inline-flex;
  align-items: center;
  gap: var(--pgm-sys-spacing-1);
}

.thirdColumn {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--pgm-sys-spacing-1);
  height: var(--pgm-sys-spacing-6);
  padding-inline: var(--pgm-sys-spacing-2);
  border-radius: var(--pgm-sys-spacing-1);
  background-color: var(--pgm-sys-color-secondary);
  color: var(--pgm-sys-color-on-secondary);
  cursor: pointer;
}

.thirdColumn[data-title]::after {
  position: absolute;
  top: calc(100% + var(--pgm-sys-spacing-1));
  left: 50%;
  z-index: 1;
  visibility: hidden;
  width: max-content;
  max-width: 240px;
  padding: var(--pgm-sys-spacing-1);
  border-radius: var(--pgm-sys-spacing-1);
  background-color: var(--pgm-sys-color-inverse-surface);
  color: var(--pgm-sys-color-inverse-on-surface);
  content: attr(data-title);
  font-size: var(--pgm-sys-typescale-label-small-size);
  line-height: var(--pgm-sys-typescale-label-small-line-height);
  text-align: center;
  opacity: 0;
  transform: translateX(-50%);
}

.thirdColumn[data-title]:hover::after {
  visibility: visible;
  opacity: 1;
}

.administrativeSelection,
.cdaSelection {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--pgm-sys-spacing-1);
  white-space: nowrap;
}

.checkboxControl {
  display: inline-flex;
  flex: 0 0 var(--pgm-sys-spacing-10);
  align-items: center;
  justify-content: center;
  width: var(--pgm-sys-spacing-10);
  height: var(--pgm-sys-spacing-10);
  margin: var(--pgm-sys-spacing-0) var(--pgm-sys-spacing-1) var(--pgm-sys-spacing-0) var(--pgm-sys-spacing-0);
  cursor: pointer;
}

.checkboxControl input {
  position: relative;
  width: var(--pgm-sys-spacing-4);
  height: var(--pgm-sys-spacing-4);
  margin: var(--pgm-sys-spacing-0);
  appearance: none;
  border: 2px solid var(--pgm-sys-color-on-surface-variant);
  border-radius: 2px;
  background: transparent;
  cursor: pointer;
}

.checkboxControl input:checked {
  border-color: var(--pgm-sys-color-primary);
  background: var(--pgm-sys-color-primary);
}

.checkboxControl input:checked::after {
  position: absolute;
  top: 0;
  left: var(--pgm-sys-spacing-1);
  width: var(--pgm-sys-spacing-1);
  height: var(--pgm-sys-spacing-2);
  border: solid var(--pgm-sys-color-on-primary);
  border-width: 0 2px 2px 0;
  content: "";
  transform: rotate(45deg);
}

.checkboxControl input:focus-visible {
  outline: 2px solid var(--pgm-sys-color-secondary);
  outline-offset: 2px;
}

.checkboxControlDisabled,
.checkboxControl input:disabled {
  cursor: default;
}

.checkboxControl input:disabled {
  opacity: 0.38;
}

.inscriptionContent {
  --row-indent: calc(var(--pgm-sys-spacing-20) + var(--pgm-sys-spacing-3));

  position: relative;
  display: flex;
  align-items: center;
  gap: var(--pgm-sys-spacing-4);
  width: calc(100% - var(--row-indent));
  height: 68px;
  min-height: 68px;
  box-sizing: border-box;
  margin-left: var(--row-indent);
  padding: var(--pgm-sys-spacing-0);
  border: 0;
  background: transparent;
}

.individualPaymentActions {
  display: flex;
  flex: 0 0 88px;
  align-items: center;
  gap: var(--pgm-sys-spacing-2);
}

.individualActionButton {
  --pgm-icon-button-shape-full: var(--pgm-sys-spacing-3);
  --md-outlined-icon-button-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-outlined-icon-button-focus-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-outlined-icon-button-hover-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-outlined-icon-button-hover-state-layer-color: var(--pgm-sys-color-on-surface-variant);
  --md-outlined-icon-button-outline-color: var(--pgm-sys-color-outline-variant);
  --md-outlined-icon-button-pressed-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-outlined-icon-button-pressed-state-layer-color: var(--pgm-sys-color-on-surface-variant);
}

.individualPaymentActions :global(.material-symbols-sharp) {
  width: var(--pgm-sys-spacing-6);
  height: var(--pgm-sys-spacing-6);
  font-size: var(--pgm-sys-spacing-6);
  line-height: var(--pgm-sys-spacing-6);
}

.cdaDetails {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-1);
  min-width: 0;
}

.cdaInformationRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--pgm-sys-spacing-1) var(--pgm-sys-spacing-6);
  min-width: 0;
}

.cdaInformationRow > span {
  min-width: 0;
}

.cdaSelection {
  flex: 0 0 auto;
  justify-content: flex-end;
  margin-left: auto;
}

.cdaBalance {
  display: inline-flex;
  align-items: center;
  gap: var(--pgm-sys-spacing-1);
}

.cdaPhase {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: var(--pgm-sys-spacing-1);
}

.labelInscription,
.processNumber {
  color: inherit;
}

.phaseName {
  display: inline-flex;
  align-items: center;
  margin: var(--pgm-sys-spacing-0);
  padding: var(--pgm-sys-spacing-1);
  border-radius: var(--pgm-sys-spacing-1);
  background-color: var(--pgm-sys-color-surface-container-highest);
}

.phaseName > strong {
  padding: var(--pgm-sys-spacing-0);
}

.withoutRefisValue {
  margin-left: var(--pgm-sys-spacing-1);
  text-decoration: line-through;
}

.addressModal {
  --pgm-button-container-height: auto;
  --pgm-button-leading-space: 0;
  --pgm-button-trailing-space: 0;
  --md-text-button-label-text-color: var(--pgm-sys-color-secondary);
  --md-text-button-hover-label-text-color: var(--pgm-sys-color-secondary);
  --md-text-button-focus-label-text-color: var(--pgm-sys-color-secondary);
  --md-text-button-pressed-label-text-color: var(--pgm-sys-color-secondary);

  width: auto;
  margin: var(--pgm-sys-spacing-0);
  padding: var(--pgm-sys-spacing-0);
  appearance: none;
  border: 0;
  background: transparent;
  color: var(--pgm-sys-color-secondary);
  cursor: pointer;
  text-decoration: underline;
}

.addressModal:hover,
.addressModal:focus {
  color: color-mix(
    in srgb,
    var(--pgm-sys-color-on-surface) 52%,
    var(--pgm-sys-color-secondary)
  );
}

.modalContentBody {
  margin-inline: calc(0px - var(--pgm-sys-spacing-1));
}

.modalTittle {
  display: flex;
  width: 100%;
  height: 47px;
  margin-top: calc(0px - var(--pgm-sys-spacing-12));
  border-radius: var(--pgm-sys-spacing-2) var(--pgm-sys-spacing-2) 0 0;
  background-color: var(--pgm-sys-color-secondary);
}

.modalTittle > span {
  margin-top: var(--pgm-sys-spacing-3);
  margin-left: var(--pgm-sys-spacing-5);
}

.modalContent {
  display: grid;
  max-width: 400px;
  max-height: 174px;
  padding: var(--pgm-sys-spacing-8);
}

.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: var(--pgm-sys-spacing-0);
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.item-inscricao-v2,
.item-inscricao-v2 strong,
.item-inscricao-v2 .addressModal,
.item-inscricao-v2 label,
.item-inscricao-v2 span:not(:global(.material-symbols-sharp)):not([role="tooltip"]) {
  @include pgm-label-large-typography;
  color: var(--pgm-sys-color-on-surface);
}

.item-inscricao-v2 .cdaInformationRow span.bodyMediumValue,
.item-inscricao-v2 span.monetaryValue,
.item-inscricao-v2 span.withoutRefisValue {
  @include pgm-body-medium-typography;
  color: var(--pgm-sys-color-on-surface-variant);
}

.item-inscricao-v2 .administrativeTotal > span.monetaryValue,
.item-inscricao-v2 .cdaBalance > span.monetaryValue {
  @include pgm-body-medium-typography;
  color: var(--pgm-sys-color-on-surface-variant);
}

.item-inscricao-v2 .cdaPhase > .phaseName,
.item-inscricao-v2 .cdaPhase > .phaseName > strong {
  @include pgm-body-small-typography;
  color: var(--pgm-sys-color-on-surface-variant);
}

@media (max-width: 768px) {
  .inscriptionInformation {
    --row-indent: var(--pgm-sys-spacing-4);

    grid-template-columns: var(--pgm-sys-spacing-12) minmax(0, 1fr);
    height: auto;
    padding-right: var(--pgm-sys-spacing-3);
  }

  .administrativeSelection {
    grid-column: 2;
  }

  .inscriptionContent {
    --row-indent: var(--pgm-sys-spacing-10);

    flex-wrap: wrap;
    height: auto;
    padding: var(--pgm-sys-spacing-3);
  }

  .individualPaymentActions {
    flex: 0 0 88px;
  }

  .cdaDetails {
    flex: 1 1 calc(100% - 104px);
  }

  .cdaSelection {
    flex: 1 0 100%;
  }
}
